// @flow

import React from 'react';
import {
  Link
} from 'react-router-dom'

import './LandingPage.css';

import logo from '../../assets/jovi-logo.svg';
import downArrow from '../../assets/downArrow.svg';
import engagement from '../../assets/engagement.svg';
import savings from '../../assets/savings.svg';
import time from '../../assets/time.svg';

export default class LandingPage extends React.Component {
  render() {
    return (
      <div>
        <div className="section home">
          <div className='topNav'>
            <a href='https://admin.jovi.rocks'>Log In</a>
            <Link to='/register/step1' className='signup'>
              Sign Up
            </Link>  
          </div>
          <img src={logo} alt="Jovi Inc." />
          <p className='tagline'>This is On Demand Video Hosting made easy. Meet Jovi.</p>
          <div className='bottom'>
            <div className='getStarted'> Get Started!</div>
            <p className='learnMore'>Learn More</p>
            <img src={downArrow} alt='Learn More' className='downArrow' />
          </div>  
        </div>
        <div className='section benefits'>
          <h1>The best tool to manage your Video</h1>
          <div className='benefits-list'>
            <div className='benefits-panel'>
              <img src={engagement} alt="engagement" />
              <h2>Easy management</h2>
              <p className='feature-summary'>
                Simply upload your video, create your chapters, set your log-in credential requirements and send it off! You can even manage multiple videos at one time.
              </p>
            </div>
            <div className='benefits-panel'>
              <img src={time} alt="Save time" />
              <h2>Save your time</h2>
              <p className='feature-summary'>
                Jovi makes it easy. Once you upload your video, we'll handle compressing it to make the viewing experience optimal for your audience. Creating chapters has never been easier with our visual "in-and-out" editing feature.
              </p>
            </div>
            <div className='benefits-panel'>
              <img src={savings} alt="Big savings" />
              <h2>Track results</h2>
              <p className='feature-summary'>
                Now the power is in YOUR hands. No longer do you need to rely on your webcast or production companies to get your video up and running. You also don't need to rely on someone else to get you the metrics on your video; with Jovi, those metrics are always available with the click of a button.
              </p>
            </div>
          </div>
          {/*<div className='all-features'>
            Interested in more?  <a href="#">View All Features</a>
          </div>*/}
        </div>
        <div className='get-started'>
          <h1>Get started for free today!</h1>
          <div className='signup'><Link to='/register/step1' className='signup'>Sign Up</Link></div>
        </div>
        <footer>
          <svg xmlns="http://www.w3.org/2000/svg" width="150" height="75" viewBox="0 0 150 75">
            <path fill="#01C8C3" fillRule="evenodd" d="M75.985 52.763c5.797-2.441 9.937-7.973 11.248-13.428a3.06 3.06 0 0 0 .078-.477c2.335 0 5.696-1.122 8.24-2.55-2.972 11.016-.145 15.91 6.308 17.289 5.355 1.144 12.198-1.337 17.231-9.136 2.006-3.1 3.791-6.82 3.908-10.278 0-.083.013-.19.026-.322.569.406 3.369 2.266 6.494 2.266-2.154 6.759-3.236 15.006 3.321 17.338 2.549.906 5.856.09 6.32-.897.14-.297-.626-.183-1.547-.45-2.911-.823-2.026-4.85.64-11.45 1.874-4.639 5.232-11.204 4.783-12.422-.7-1.9-7.746-2.746-9.343-1.91-1.482.777-2.342 3.733-3.002 5.76-3.87 0-6.89-1.192-7.68-1.884-.336-1.61-1.293-3.22-3.739-3.84-2.316-.596-4.426.108-3.598 2.529.79 2.277.572 9.099-2.511 14.596-4.013 7.158-10.802 9.128-10.802 6.45 0-2.101 1.143-5 2.784-9.923 3.64-10.92 1.174-15.926-7.302-14.248-1.643.326.292 8.625-10.505 9.647.077-4.173-2.653-8.61-8.152-8.61-2.384 0-4.122.894-5.225 2.15-7.109-2.907-9.002-1.603-10.029-.885-5.576 3.9-8.98 15.877-3.784 21.58 4.54 4.983 11.17 5.071 15.838 3.105zM65.994 42.65c.896-4.517 3.567-8.12 6.411-9.994 0 .506.074 1 .22 1.462 1.08 3.364 4.43 5.088 8.36 5.076-1.848 7.865-7.232 12.176-10.994 11.662-3.697-.505-4.766-4.335-3.997-8.206zm81.21-30.303c3.021 1.774 3.7 5.071 1.516 7.365-2.184 2.293-6.403 2.715-9.425.94-3.02-1.773-3.699-5.07-1.515-7.364 2.184-2.293 6.403-2.714 9.424-.94zm-3.808 45.03c.4.059.703.19.9.387.181.18.244.398.179.613-1.935 6.329-5.489 6.988-12.704 7.775-11.894 1.296-23.745 1.435-46.514-1.298-15.8-1.897-28.473-5.462-32.14-6.984-2.07-.86-3.385-1.582-3.07-2.317.308-.72.91-.563 2.464-.206 13.26 3.04 32.35 3.723 54.304 3.855 15.326.092 25.79-.946 31.33-1.504 2.946-.296 4.424-.445 5.25-.322zM42.716 2.227C55.14 9.022 57.104 28.16 49.597 46.202 40.561 67.92 18.553 80.4 5.707 72.727c-7.434-4.44-7.616-13.967-.483-19.886 6.964-5.778 19.217-5.9 24.86-3.782 1.903.713 1.171 1.901-.572 1.704-6.597-.746-13.722.114-18.286 3.863-4.098 3.366-5.608 9.883-.95 12.776 7.164 4.45 18.511-1.735 24.955-12.381 6.407-10.586 7.823-18.44 7.823-28.744 0-9.122-4-16.577-10.777-16.962-5.133-.292-9.692 3.809-10.72 9.039-1.886 9.588 4.02 18.417 9.71 22.923 1.296 1.027.059 2.082-1.455 1.49-6.641-2.599-18.423-12.917-16.044-26.3C16.616.443 33.316-2.912 42.716 2.228z" />
          </svg>
          <p>Copyright 2017. All Rights Reserved.</p>
        </footer>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPage.jsx